import { jsx as g } from "react/jsx-runtime";
import "react";
import { classNames as y } from "../../utilities/index.js";
const f = ({ src: i, srcSet: l, loading: a = "lazy", priority: m = !1, className: e, objectFit: s = "cover", objectPosition: r = "center", aspectRatio: o, ...n }) => {
  const t = !m && a === "lazy", c = y({
    "sash-Image inline-block max-w-full transition-opacity duration-1000": !0,
    [e]: e
  });
  return /* @__PURE__ */ g(
    "img",
    {
      src: i,
      srcSet: l,
      decoding: "async",
      fetchpriority: t ? "low" : "high",
      loading: t ? a : "eager",
      className: c,
      style: o ? { aspectRatio: o, objectFit: s, objectPosition: r } : { objectFit: s, objectPosition: r },
      ...n
    }
  );
}, h = f;
export {
  h as default
};
